<!-- 客户邮件 -->
<template>
  <div class="content">
    <div class="filter">
      <el-input placeholder="请输入关键字" v-model="searchContent" class="input-with-select" @blur="search" @keyup.enter.native="search" clearable @clear="handleClear">
        <el-select v-model="searchType" slot="prepend" placeholder="请选择" @change="handleChange" style="width:130px">
          <el-option label="邮箱/手机号" :value="3"></el-option>
          <el-option label="用户名" :value="1"></el-option>
          <el-option label="用户ID" :value="2"></el-option>
        </el-select>
      </el-input>
      <el-select v-model="listForm.userGroup" placeholder="用户分组" clearable @change="initPage">
        <el-option v-for="item in group" :label="item.name" :key="item.code" :value="item.code"></el-option>
      </el-select>
      <el-select v-model="listForm.approvalStatus" placeholder="资质认证" @change="initPage" style="width:120px" clearable>
        <el-option label="未认证" :value="0"></el-option>
        <el-option label="已认证" :value="3"></el-option>
        <el-option label="审核中" :value="1"></el-option>
        <el-option label="认证失败" :value="2"></el-option>
      </el-select>
      <el-date-picker v-model="registerDate" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="timestamp" :default-time="['00:00:00', '23:59:59']" @change="handleDatePick"></el-date-picker>
    </div>

    <el-table :data="list" height="calc(100vh - 198px)" @selection-change="handleSelectionChange">
      <el-table-column type="selection" min-width="55"></el-table-column>
      <el-table-column prop="userId" label="ID" min-width="150" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="fullName" label="客户名" min-width="150" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column label="邮箱/手机号" min-width="150" :show-overflow-tooltip="true">
        <template slot-scope="{row}">
          <div>{{ row.email }}</div>
          <div>{{ row.phone }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="area" label="国家" min-width="100" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="ifCertification" label="资质认证" min-width="100" :show-overflow-tooltip="true">
        <template slot-scope="{row}">
          {{getStatu(row.approvalStatus)}}
        </template>
      </el-table-column>
      <el-table-column prop="ifBindStore" label="是否绑定店铺" min-width="150" :show-overflow-tooltip="true">
        <template slot-scope="{row}">
          {{row.ifBindStore===0?'否':'是'}}
        </template>
      </el-table-column>
      <!-- <el-table-column prop="id" label="客户标签（本期不做）" min-width="150" :show-overflow-tooltip="true"></el-table-column> -->
      <el-table-column prop="userGroupName" label="客户分组" min-width="100" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="referrer" label="来源" min-width="180" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="registerDate" label="注册时间" min-width="180" :show-overflow-tooltip="true">
        <template slot-scope="{row}">
          <span>{{row.registerDate|dateFormat}}</span>
        </template>
      </el-table-column>

      <el-table-column label="操作" width="180">
        <template slot-scope="{row}">
          <el-button type="text" size="medium" @click="showDetail(row)">详情</el-button>
          <el-button type="text" size="medium" v-show="row.approvalStatus===1" @click="certificate(row)">认证审核</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="f-b-c bg-white" style="padding: 10px">
      <div></div>
      <el-pagination background :current-page="listForm.pageNumber" :page-sizes="[20, 50, 100, 200, 500]" :page-size="listForm.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" class="el-pagination" @size-change="handleSizeChange" @current-change="pageChange" />
    </div>
  </div>
</template>

<script>
import API from '@/api'
// import { dateFormat } from '@/utils/date'
export default {
  name: 'customer_management',
  data() {
    return {
      total: 0,
      list: [],
      listForm: {
        pageNumber: 1,
        pageSize: 20,
      },
      searchContent: '',
      searchType: 3,
      registerDate: [],
      group: [],
    }
  },
  computed: {
    getStatu() {
      return (statu) => {
        switch (statu) {
          case 0:
            return '未认证'
          case 1:
            return '审核中'
          case 2:
            return '认证失败'
          case 3:
            return '已认证'
          default:
            break;
        }
      }
    }
  },
  created() {
    this.getCustomerList()
    this.getAllUserGroup()
  },
  activated(){
    if(this.$route.query.type){
      this.clearParam()
      this.$set(this.listForm,'approvalStatus',+this.$route.query.type)
    }
    this.getCustomerList()
  },

  methods: {
    getCustomerList() {
      let form = { ...this.listForm }
      if (this.searchType === 1) {
        form.fullName = this.searchContent
      } else if (this.searchType === 2) {
        form.userId = this.searchContent
      } else {
        form.email = this.searchContent.trim()
      }
      API.getCustomerList(form).then(res => {
        this.list = res.data.list
        this.total = res.data.total
      })
    },

    getAllUserGroup() {
      API.getAllUserGroup().then(res => {
        this.group = res.data
      })
    },

    //时间筛选
    handleDatePick(value) {
      if (value && value.length === 2) {
        this.listForm.registerDateStart = value[0]
        this.listForm.registerDateEnd = value[1]
      } else {
        this.listForm.registerDateStart = undefined
        this.listForm.registerDateEnd = undefined
      }
      this.initPage()
    },

    // 清除参数
    clearParam() {
      this.searchContent = ''
      this.$set(this.listForm,'userGroup', undefined)
      this.$set(this.listForm,'approvalStatus', undefined)
      this.registerDate = undefined
      this.listForm.registerDateStart = undefined
      this.listForm.registerDateEnd = undefined
    },

    initPage() {
      this.listForm.pageNumber = 1
      this.getCustomerList()
    },

    pageChange(page) {
      this.listForm.pageNumber = page
      this.getCustomerList()
    },
    handleSizeChange(pageSize) {
      this.listForm.pageSize = pageSize
      this.getCustomerList()
    },
    search() {
      this.listForm.pageNumber = 1
      this.getCustomerList()
    },
    handleClear() {
      this.listForm.pageNumber = 1
      this.getCustomerList()
    },
    handleSelectionChange(val) {
      console.log(val);
    },
    handleChange() {
      this.searchContent = ''
    },
    showDetail(row) {
      this.$router.push({
        path: '/customer/management/detail',
        query: {
          id: row.userId
        }
      })
    },
    certificate(row) {
      this.$router.push({
        path: '/customer/management/certification',
        query: {
          id: row.userId
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.content {
  height: 100%;
  background: #ffffff;
  padding: 12px 12px 0;
  .filter {
    padding: 12px;
    & > div {
      margin-left: 12px;
    }
    /deep/.el-input-group {
      width: 300px;
    }
    /deep/.el-input-group__prepend {
      width: 100px;
    }
  }
}
</style>>
